<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-alert v-if="mpn || wpn || lpn" type="info" border="left" elevation="3" outlined colored-border>
          For your reference, here are your current placement levels:
          <div class="ml-4" style="font-style: italic;">*Note that if you recently completed the math placement test or uploaded a writing sample, then the Math and Writing levels may be incorrect.</div>
          <div v-if="mpn">Math Placement Level: {{ mpn }}</div>
          <div v-if="wpn">Writing Placement Level: {{ wpn }}</div>
          <div v-if="lpn">Language Placement: {{ lpn }}</div>
        </v-alert>
        <p>If you have taken any AP, CLEP, or International Baccalaureate exams, please select the exam, when you took it, and your score. You can find more information in <a href="http://catalog.covenant.edu/content.php?catoid=10&navoid=256#Advanced_Placement__International_Baccalaureate_and_CLEP_Examinations" target="_blank">the college catalog</a>.</p>
        <p>This form will only accept scores that will grant credit (<a href="http://catalog.covenant.edu/content.php?catoid=10&navoid=256#Advanced_Placement__International_Baccalaureate_and_CLEP_Examinations" target="_blank">see the college catalog for more details</a>).<br/>These scores are:</p>
        <ul class="browser-default" style="padding: .5em 1em 1em; margin-left: 3em;">
          <li style="list-style-type:disc">AP: 4 - 5</li>
          <li style="list-style-type:disc">CLEP: 50 - 80</li>
          <li style="list-style-type:disc">IB: 5 - 7</li>
        </ul>
        <prereg-tests @change="(val) => tests = val"></prereg-tests>
        <v-divider style="margin:1em 0"></v-divider>
        <prereg-transfer @change="(val) => { studentType = val.studentType; colleges = val.colleges }"></prereg-transfer>
        <v-alert v-if="studentType !== 'None' && studentType !== '' && colleges.length === 0" type="error" style="margin-top:1em">If you have any college credits, you must add the college(s) in this form.</v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="next()">Continue</v-btn>
      <v-btn @click="$emit('back')">Back</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref } from '@vue/composition-api'
export default {
  components: {
    PreregTests: () => import('./parts/tests'),
    PreregTransfer: () => import('./parts/transfer')
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    mpn: Number,
    wpn: Number,
    lpn: String
  },
  setup (props, { root, emit }) {
    const form = ref(null)
    const tests = ref([])
    const studentType = ref('N')
    const colleges = ref([])

    function next () {
      if (form.value.validate()) {
        if (studentType.value === 'None' || colleges.value.length > 0) {
          let obj = { studentType: studentType.value }
          if (tests.value.length > 0) obj.test = tests.value
          if (colleges.value.length > 0) obj.colleges = colleges.value
          emit('next', obj)
        }
      }
    }

    return {
      form,
      tests,
      studentType,
      colleges,
      next
    }
  }
}
</script>
